module.exports = __webpack_public_path__ + "static/texture-lifeguard-stand-f5f30d2d11d23cd57728966b607f9fc1.png";